var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M32,6 C33.1045695,6 34,6.8954305 34,8 L34,32 C34,33.1045695 33.1045695,34 32,34 L25.102,34 L25.1022225,22.9000005 L28.5594449,22.9000005 L29.0533338,18.666667 L25.1022225,18.666667 L25.1022225,16.1531252 C25.1022225,15.535761 25.2154043,15.0947932 25.4417712,14.8302085 C25.668138,14.5656238 26.1723113,14.4333335 26.9543059,14.4333335 L26.9543059,14.4333335 L29.0533338,14.4333335 L29.0533338,10.2 L25.5961114,10.2 C23.5793883,10.2 22.1388934,10.6740404 21.2745835,11.6221355 C20.4102736,12.5702305 19.9781251,13.9703034 19.9781251,15.8223961 L19.9781251,15.8223961 L19.9781251,18.666667 L17.2,18.666667 L17.2,22.9000005 L19.9781251,22.9000005 L19.978,34 L8,34 C6.8954305,34 6,33.1045695 6,32 L6,8 C6,6.8954305 6.8954305,6 8,6 L32,6 Z",
    id: "Combined-Shape"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.698edd73c0e30ad8e99089d1f5f1e89c.svg";
export { ForwardRef as ReactComponent };